import {
  BooleanField,
  Datagrid,
  List,
  TextField,
} from 'react-admin';

export const SlackNotificationChannelsList = () => (
  <List sort={{ field: 'workflow', order: 'ASC' }}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <TextField source="workflow" label="Workflow" />
      <BooleanField source="enabled" />
      <TextField
        source="webhookUrlConfigured"
        label="Webhook configured"
        sortable={false}
      />
    </Datagrid>
  </List>
);
